module.exports = __webpack_public_path__ + "header-profile-skin-2.8307c45ca34d4af71912.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/assets/styles/patterns/header-profile-skin-2.png
// module id = ../../../../../src/assets/styles/patterns/header-profile-skin-2.png
// module chunks = styles